import { render } from "./PayyoPaymentMethod.vue?vue&type=template&id=7bd1747b"
import script from "./PayyoPaymentMethod.vue?vue&type=script&lang=js"
export * from "./PayyoPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__